<template>
  <div ref="container">
    <a-drawer
      :title="title"
      width="87vw"
      :visible="visible"
      :maskClosable="false"
      :mask="false"
      :confirmLoading="confirmLoading"
      :wrapClassName="wrapClassNameInfo()"
      @ok="handleOk"
      @close="handleCancel"
      cancelText="取消"
      okText="保存"
      :destroyOnClose="true">
      <a-row :gutter="24">
        <a-form>
          <a-row :gutter="24">
            <a-col :md="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则名称">
                <a-input placeholder="请输入规则名称" v-model="qveData.ruleName" v-show="false"/>{{ qveData.ruleName ? qveData.ruleName : '无' }}
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则编码">
                <a-input placeholder="请输入规则编码" v-model="qveData.ruleCode" v-show="false"/>{{ qveData.ruleCode ? qveData.ruleCode : '无' }}
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发码机构">
                  <a-input placeholder="请输入规则编码" v-model="qveData.ruleCode" v-show="false"/>{{ qveData.ruleSystem ? qveData.ruleSystem : '无' }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考标准">
                  <a-input placeholder="请输入规则编码" v-model="qveData.ruleCode" v-show="false"/>{{ qveData.ruleCategory ? qveData.ruleCategory : '无' }}
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="更新时间">
                <a-input placeholder="请输入规则编码" v-model="qveData.updateTime" v-show="false"/>{{ qveData.updateTime ? qveData.updateTime : '无' }}
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                  <a-input placeholder="请输入规则编码" v-model="qveData.ruleCode" v-show="false"/>{{ qveData.remark ? qveData.remark : '无' }}
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-row>
      <a-row :gutter="24">
      <a-col :md="24">
        <a-card>
          <!-- table区域-begin -->
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="uuid"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.uuid)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <!-- 状态渲染模板 -->
              <template slot="customRenderFlag" slot-scope="enabled">
                <a-tag v-if="enabled==1" color="green">启用</a-tag>
                <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
              </template>
            </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
    </a-drawer>
  </div>
</template>
<script>
  import pick from 'lodash.pick'
  import { makeCodeRecordListModalList, generatedDetailById, queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {autoJumpNextInput} from "@/utils/util"
  import {mixinDevice} from '@/utils/mixin'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  export default {
    name: "MakeCodeRecordListModal",
    mixins: [mixinDevice, JeecgListMixin],
    components: {
      JSelectMultiple
    },
    data () {
      return {
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },

        // 查询条件
        queryParam: {
          ruleId: this.ruleId
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width: '5%',
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {title: '编码 ', dataIndex: 'idCode',  align:"center"},
          {title: '短码 ', dataIndex: 'shortNum',  align:"center"},
        ],
        url: {
          list: "/codeRules/fzIdcodeBatch/list",
          delete: "/codeRules/fzIdcodeBatch/delete",
          deleteBatch: "/codeRules/fzIdcodeBatch/deleteBatch"
        },

        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{

        },
        uuid: null,
        ruleId: null,
        qveData: null,
        qveData2: null,
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
              return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
      }
    },
    created () {
    },
    methods: {
      add (qve) {
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
        this.visible = true;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.id){
          this.jselectMultiple.value = record.pushBtn
        } else {
          this.jselectMultiple.value = ''
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'number', 'name', 'parentNumber', 'parentName', 'url', 'component', 'sort', 'pushBtn', 'icon', 'enabled'))
          autoJumpNextInput('functionModal')
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.ipagination.current = 1
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            let obj;
            if(!this.model.id){
              obj=addFunction(formData);
            }else{
              obj=editFunction(formData);
            }
            obj.then((res)=>{
              if(res.code === 200){
                that.$emit('ok');
              }else{
                that.$message.warning(res.data.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      async handleTableChange(pagination, filters, sorter){
        this.ipagination.current = pagination.current
        this.ipagination.pageSize = pagination.pageSize
        makeCodeRecordListModalList({uuid: this.uuid, ruleId: this.ruleId, pageNo: this.ipagination.current, pageSize: this.ipagination.pageSize})
        .then(res => {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        })
        await generatedDetailById({ id: this.ruleId, uuid: this.uuid })
        .then(res => {
          this.qveData = res.result
        })

        // 获取发码机构下拉框
        await queryEnableDictItemsByCode({code: 'send_code_org'})
        .then(res => {
           let index = res.findIndex(obj => obj.value === this.qveData.ruleSystem);
           if(index != -1){
             this.qveData.ruleSystem = res[index].label
           }
        })
        // 获取参考标准下拉框
        await queryEnableDictItemsByCode({code: 'Reference_Standards'})
        .then(res => {
          let index = res.findIndex(obj => obj.value === this.qveData.ruleCategory);
            if(index != -1){
              this.qveData.ruleCategory = res[index].label
            }
        })
        this.visible = true;
      },
      async getList(uuid, ruleId) {
        this.uuid = uuid
        this.ruleId = ruleId
        this.topQueryParam.uuid = uuid
        this.topQueryParam.ruleId = ruleId
        makeCodeRecordListModalList({uuid: this.uuid, ruleId: this.ruleId, pageNo: this.ipagination.current, pageSize: this.ipagination.pageSize})
        .then(res => {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        })

        await generatedDetailById({ id: this.ruleId, uuid: this.uuid })
        .then(res => {
          this.qveData = res.result
        })

        // 获取发码机构下拉框
        await queryEnableDictItemsByCode({code: 'send_code_org'})
        .then(res => {
           let index = res.findIndex(obj => obj.value === this.qveData.ruleSystem);
           if(index != -1){
             this.qveData.ruleSystem = res[index].label
           }
        })
        // 获取参考标准下拉框
        await queryEnableDictItemsByCode({code: 'Reference_Standards'})
        .then(res => {
          let index = res.findIndex(obj => obj.value === this.qveData.ruleCategory);
            if(index != -1){
              this.qveData.ruleCategory = res[index].label
            }
        })
        this.visible = true;
      },
      searchReset2() {
        makeCodeRecordListModalList({uuid: this.uuid, ruleId: this.ruleId, pageNo: this.ipagination.current, pageSize: this.ipagination.pageSize})
        .then(res => {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        })
      }
    }
  }
</script>